<div>
  <form [formGroup]="openTrackingForm">
    <mat-card>
      @if (!isAfterLogin) {
        <div>
          <button mat-button color="primary" class="back-to-login-btn" (click)="backToLoginPge()">
            <span id="login-text">Back To Log-In</span>
          </button>
          <div class="d-flex justify-content-center" [ngStyle]="{'margin-top': isDataFetched ? '0px' : '100px'}">
            <img src="assets/img/grt_logo.png" alt="GRT GLOBAL LOGISTIC PVT LTD">
          </div>
        </div>
      }

      <div class="sticky-container">
        @if (!isAfterLogin) {
          <h3 class="d-flex justify-content-center blue-bold-text" id="trackingDet">TRACKING DETAILS</h3>
        }
        <mat-card-content class="search-bar-content">
          <div class="search-controls">
            <select formControlName="type" class="dd">
              <option value="blNo">BL No</option>
              <option value="billNo">Shipping Bill</option>
            </select>
            <input formControlName="searchValue" class="field" placeholder="{{type.value == 'billNo' ? 'Enter Shipping bill No' : 'Enter BL No'}}" required>
            <button mat-button color="primary" (click)="getTracking()" id="login" class="track-btn"> TRACK </button>
            @if (isDataFetched && isLogin) {
              <button mat-button color="primary" (click)="getEmail()" id="login" class="email-btn"> EMAIL TRACKING </button>
            }
            <mat-slide-toggle class="blue-theme-toggle" (change)="showTable = $event.checked">
              <span class="toggle-label">{{ showTable ? 'Card View' : 'Table View' }}</span>
            </mat-slide-toggle>
          </div>
        </mat-card-content>
        @if (searchValue.touched && searchValue.invalid) {
          <div class="error-message">
            {{ getSearchvalueErrorMessage() }}
          </div>
        }

        <!-- ── Timeline ── -->
        @if (data) {
          <div class="timeline">
            <!-- CARTING -->
            <div id="carting-step" class="tl-step" [ngClass]="{ 'tl-completed': data?.isCarted }" (click)="myFunction('booking')">
              <div class="tl-icon">
                <img src="assets/img/carting.png" alt="Carting" class="tl-img">
              </div>
              <div class="tl-dot"></div>
              <div class="tl-title">CARTING</div>
              <div class="tl-date">
                @if (data) {
                  <span>{{ data?.isBlNo ? 'Find Below' : data?.isCfs ? data?.billDetails[0]?.cartingDate : data?.billDetails[0]?.readyDate }}</span>
                }
              </div>
            </div>
            <!-- TNTV STUFF -->
            <div id="planning-step" class="tl-step" [ngClass]="{ 'tl-completed': data?.isCarted }" (click)="data.isOnBoarded ? myFunction('stuffing') : myFunction('planning')">
              <div class="tl-icon">
                <img src="assets/img/planning.png" alt="Planning" class="tl-img">
              </div>
              <div class="tl-dot"></div>
              <div class="tl-title">TNTV STUFF</div>
              <div class="tl-date">
                @if (data?.isCarted) {
                  <span>{{ data?.voyageStuffingDate }}</span>
                }
              </div>
            </div>
            <!-- STUFFING -->
            <div id="stuffing-step" class="tl-step" [ngClass]="{ 'tl-completed': data?.isPlanned && data?.isStuffed }" (click)="myFunction('stuffing')">
              <div class="tl-icon">
                <img src="assets/img/stuffing.png" alt="Stuffing" class="tl-img">
              </div>
              <div class="tl-dot"></div>
              <div class="tl-title">STUFFING</div>
              <div class="tl-date">
                @if (data?.isPlanned && data?.isStuffed) {
                  <span>{{ data?.stuffingDate }}</span>
                }
              </div>
            </div>
            <!-- ONBOARD -->
            <div id="onboard-step" class="tl-step" [ngClass]="{ 'tl-completed': data?.isStuffed && data?.isOnBoarded }" (click)="myFunction('loading')">
              <div class="tl-icon">
                <img src="assets/img/onboard.png" alt="OnBoard" class="tl-img">
              </div>
              <div class="tl-dot"></div>
              <div class="tl-title">ONBOARD</div>
              <div class="tl-date">
                @if (data?.isStuffed && data?.isOnBoarded) {
                  <span>{{ data?.onBoardDate }}</span>
                }
              </div>
            </div>
            <!-- SAILING -->
            <div id="sailing-step" class="tl-step" [ngClass]="{ 'tl-completed': data?.isOnBoarded && data?.isSailed && data?.isStuffed }" (click)="myFunction('loading')">
              <div class="tl-icon">
                <img src="assets/img/sailing.png" alt="Sailing" class="tl-img">
              </div>
              <div class="tl-dot"></div>
              <div class="tl-title">SAILING</div>
              <div class="tl-subtitle">{{ data.polName ? '(' + data.polName + ')' : '' }}</div>
              <div class="tl-date">
                @if (data?.isOnBoarded && data?.isSailed && data?.isStuffed) {
                  <span>{{ data?.loadingSailDate }}</span>
                }
              </div>
            </div>
            <!-- ARR DESTN -->
            <div id="arrival-step" class="tl-step" [ngClass]="{ 'tl-completed': data?.isSailed && data?.isArrived && data?.isOnBoarded }" (click)="myFunction('lineRoute')">
              <div class="tl-icon">
                <img src="assets/img/arrival.png" alt="Arrival" class="tl-img">
              </div>
              <div class="tl-dot"></div>
              <div class="tl-title">ARR DESTN</div>
              <div class="tl-subtitle">{{ data.destinationName ? '(' + data.destinationName + ')' : '' }}</div>
              <div class="tl-date">
                @if (data?.isSailed && data?.isArrived && data?.isOnBoarded) {
                  <span>{{ data?.loadingAtaDate }}</span>
                }
              </div>
            </div>
            <!-- DESTUFF -->
            <div id="destuffing-step" class="tl-step" [ngClass]="{ 'tl-completed': data?.isArrived && data?.destuffingDate && data?.isSailed && data?.isOnBoarded }" (click)="myFunction('forwarding')">
              <div class="tl-icon">
                <img src="assets/img/destuffing.png" alt="Destuffing" class="tl-img">
              </div>
              <div class="tl-dot"></div>
              <div class="tl-title">DESTUFF</div>
              <div class="tl-date">
                @if (data?.isArrived && data?.destuffingDate && data?.isSailed && data?.isOnBoarded) {
                  <span>{{ data?.destuffingDate }}</span>
                }
              </div>
            </div>
            <!-- DO ISSUE -->
            <div id="doissue-step" class="tl-step" [ngClass]="{ 'tl-completed': data?.destuffingDate && data?.isDoIssued && data?.isArrived && data?.isSailed && data?.isOnBoarded }" (click)="myFunction('forwarding')">
              <div class="tl-icon">
                <img src="assets/img/DO_Issue.png" alt="DoIssue" class="tl-img">
              </div>
              <div class="tl-dot"></div>
              <div class="tl-title">DO ISSUE</div>
              <div class="tl-date">
                @if (data) {
                  <span>{{ data?.doReleaseDate }}</span>
                }
              </div>
            </div>
          </div>
        }
      </div>

      @if (data) {
        <div [ngClass]="isAfterLogin ? 'details':'x-details'" >
          @if (data) {
            <div>
              <div class="flex-container">
                <h3 class="block-heading section-heading-media">Images & Videos</h3>
                <h3 class="joint"></h3>
              </div>
              <div class="header-toolbar">
                <h4 class="label-title">Total Number Of Shipping Bills : {{ shippingBillNos.length }}</h4>
                <button mat-raised-button color="primary" (click)="toggleAll()">{{ allExpanded ? '▲ Collapse' : '▼ Expand' }}</button>
              </div>
              <div class="mat-chip-list-wrapper">
                <mat-accordion multi="true">
                  @for (bill of shippingBillNos; track bill; let i = $index) {
                    <mat-expansion-panel  [expanded]="shippingBillExpanded[i]" (opened)="onShippingBillOpened(bill) ; onShippingBillToggled(i, true)" (closed)="onShippingBillToggled(i, false)" class="custom-expansion-panel">
                      <mat-expansion-panel-header class="custom-header">
                        <mat-panel-title><mat-icon>article</mat-icon> {{i + 1}} . Shipping Bill: {{ bill.No }} (PHOTO : {{ bill.photoCount }}, VIDEO : {{ bill.videoCount }})</mat-panel-title>
                      </mat-expansion-panel-header>
                      <!-- Carting Section -->
                      <div class="media-section">
                        <h4 class="section-title">Carting Media</h4>
                        @if (billCartingMediaMap[bill.id]?.length > 0) {
                          <p class="media-label">Images</p>
                          <div class="media-scroll-container">
                            @for (file of billCartingMediaMap[bill.id]; track file) {
                              @if (file.type === 'image') {
                                <div class="media-wrapper">
                                  <img [src]="file.url" alt="Carting Image" class="media-item" (click)="openPreview(file)" />
                                  <button mat-icon-button class="download-icon" matTooltip="Download Image"
                                    (click)="downloadImage(file.fileStorage, file.url); $event.stopPropagation()"><mat-icon>save_alt</mat-icon></button>
                                  </div>
                                }
                              }
                            </div>
                            <p class="media-label">Videos</p>
                            <div class="media-scroll-container">
                              @for (file of billCartingMediaMap[bill.id]; track file) {
                                @if (file.type === 'video') {
                                  <div class="media-wrapper">
                                    <video class="media-item" muted playsinline (mouseenter)="playVideo($event)"
                                      (mouseleave)="pauseVideo($event)" (click)="openPreview(file)">
                                      <source [src]="file.url" [type]="getMimeType(file.name)" />
                                      Your browser does not support the video tag.
                                    </video>
                                    <button mat-icon-button class="download-icon" matTooltip="Download Video"
                                      (click)="downloadImage(file.fileStorage, file.url); $event.stopPropagation()"><mat-icon>save_alt</mat-icon></button>
                                    </div>
                                  }
                                }
                              </div>
                            } @else {
                              <p class="no-media-msg"><strong>No Carting Media Available.</strong></p>
                            }
                          </div>
                          <!-- Stuffing Section -->
                          <div class="media-section">
                            <h4 class="section-title">Stuffing Media</h4>
                            @if (billStuffingMediaMap[bill.id]?.length > 0) {
                              <p class="media-label">Images</p>
                              <div class="media-scroll-container">
                                @for (file of billStuffingMediaMap[bill.id]; track file) {
                                  @if (file.type === 'image') {
                                    <div class="media-wrapper">
                                      <img [src]="file.url" alt="Stuffing Image" class="media-item" (click)="openPreview(file)" />
                                      <button mat-icon-button class="download-icon" matTooltip="Download Image"
                                        (click)="downloadImage(file.fileStorage, file.url); $event.stopPropagation()"><mat-icon>save_alt</mat-icon></button>
                                      </div>
                                    }
                                  }
                                </div>
                                <p class="media-label">Videos</p>
                                <div class="media-scroll-container">
                                  @for (file of billStuffingMediaMap[bill.id]; track file) {
                                    @if (file.type === 'video') {
                                      <div class="media-wrapper">
                                        <video class="media-item" muted playsinline (mouseenter)="playVideo($event)"
                                          (mouseleave)="pauseVideo($event)" (click)="openPreview(file)">
                                          <source [src]="file.url" [type]="getMimeType(file.name)" />
                                          Your browser does not support the video tag.
                                        </video>
                                        <button mat-icon-button class="download-icon" matTooltip="Download Video"
                                          (click)="downloadImage(file.fileStorage, file.url); $event.stopPropagation()"><mat-icon>save_alt</mat-icon></button>
                                        </div>
                                      }
                                    }
                                  </div>
                                } @else {
                                  <p class="no-media-msg"><strong>No Stuffing Media Available.</strong></p>
                                }
                              </div>
                            </mat-expansion-panel>
                          }
                        </mat-accordion>
                        <!-- Container Section -->
                        <mat-accordion multi="true">
                          @for (stuff of stuffingNos; track stuff; let i = $index) {
                            <mat-expansion-panel [expanded]="containerExpanded[i]" (opened)="onStuffingPanelOpened(stuff.id) ; onContainerToggled(i, true)" (closed)="onContainerToggled(i, false)" class="custom-expansion-panel">
                              <mat-expansion-panel-header class="custom-header">
                                <mat-panel-title><mat-icon>inventory_2</mat-icon>{{i + 1}} . Container No: {{ stuff.No }} (PHOTO : {{ stuff.photoCount }}, VIDEO : {{ stuff.videoCount }})</mat-panel-title>
                              </mat-expansion-panel-header>
                              @if (filteredMedia?.length > 0) {
                                <p class="media-label"> Container Images</p>
                                <div class="media-scroll-container">
                                  @for (file of filteredMedia; track file) {
                                    @if (file.type === 'image') {
                                      <div class="media-wrapper">
                                        <img [src]="file.url" alt="Container Image" class="media-item" (click)="openPreview(file)" />
                                        <button mat-icon-button class="download-icon" matTooltip="Download Image"
                                          (click)="downloadImage(file.fileStorage, file.url); $event.stopPropagation()"><mat-icon>save_alt</mat-icon></button>
                                        </div>
                                      }
                                    }
                                  </div>
                                  <p class="media-label">Container Videos</p>
                                  <div class="media-scroll-container">
                                    @for (file of filteredMedia; track file) {
                                      @if (file.type === 'video') {
                                        <div class="media-wrapper">
                                          <video class="media-item" muted playsinline (mouseenter)="playVideo($event)"
                                            (mouseleave)="pauseVideo($event)" (click)="openPreview(file)">
                                            <source [src]="file.url" [type]="getMimeType(file.name)" />
                                            Your browser does not support the video tag.
                                          </video>
                                          <button mat-icon-button class="download-icon" matTooltip="Download Video"
                                            (click)="downloadImage(file.fileStorage, file.url); $event.stopPropagation()"><mat-icon>save_alt</mat-icon></button>
                                          </div>
                                        }
                                      }
                                    </div>
                                  } @else {
                                    <p class="no-media-msg">No Container Media available.</p>
                                  }
                                </mat-expansion-panel>
                              }
                            </mat-accordion>
                          </div>
                        </div>
                      }
                      <!-- Media Preview Modal -->
                      @if (isPreviewOpen) {
                        <div class="media-modal">
                          <span class="close-btn" (click)="closePreview()">&times;</span>
                          @if (mediaPreviewList.length > 1) {
                            <span class="nav-arrow left" (click)="prevMedia()">&#10094;</span>
                          }
                          @if (mediaPreviewList.length > 1) {
                            <span class="nav-arrow right" (click)="nextMedia()">&#10095;</span>
                          }
                          <div class="media-preview">
                            <div class="media-info">
                              @if (currentMedia?.billNo) {
                                <p class="bill-info">
                                  Shipping Bill No: <strong>{{ currentMedia.billNo }}</strong>
                                </p>
                              }
                              @if (currentMedia?.contNo) {
                                <p class="bill-info">
                                  Container No: <strong>{{ currentMedia.contNo }}</strong>
                                </p>
                              }
                            </div>
                            @if (currentMedia?.type === 'image') {
                              <img [src]="currentMedia.url" [alt]="currentMedia.name" />
                            }
                            @if (currentMedia?.type === 'video') {
                              <video
                                [src]="currentMedia.url" [attr.type]="getMimeType(currentMedia.name)" controls autoplay muted>
                                Your browser does not support the video tag.
                              </video>
                            }
                            @if (mediaPreviewList.length) {
                              <div class="media-preview-counter">
                                {{ currentMediaIndex + 1 }} of {{ mediaPreviewList.length }}
                              </div>
                            }
                            <button mat-icon-button class="download-icon" matTooltip="Download"
                              (click)="downloadImage(currentMedia.fileStorage, currentMedia.url); $event.stopPropagation()"><mat-icon>save_alt</mat-icon></button>
                            </div>
                          </div>
                        }
                        <!-- linear tracking  -->
                        @if (data && !showTable) {
                          <div>
                            <div class="linearTitle-bar">
                              <h2 class="linearTitle-text">Shipping Bill Details</h2>
                              <button class="copy-all-btn" (click)="copyEntireTable()" matTooltip="Copy to clipboard" matTooltipPosition="right">
                                <mat-icon>content_copy</mat-icon>
                              </button>
                            </div>
                            <div #tableContentToCopy style="text-align: center;">
                              @if (data) {
                                <mat-card-content class="headerTable">
                                  <table mat-table [dataSource]="linearOutputDataSource">
                                    <ng-container matColumnDef="blNo">
                                      <th mat-header-cell id="table-th" *matHeaderCellDef>HBL No.</th>
                                      <td mat-cell id="table-td" *matCellDef="let element">
                                        {{ this.data?.blNo ? this.data?.blNo : 'HBL Not Generated' }}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="billNo">
                                      <th mat-header-cell id="table-th" *matHeaderCellDef>SBill No.</th>
                                      <td mat-cell id="table-td" *matCellDef="let element;">
                                        {{ element?.billNo ? element?.billNo : '---' }}<br>
                                      ({{ element?.originName ? element?.originName : '---' }})</td>
                                    </ng-container>
                                    <ng-container matColumnDef="cartingDate">
                                      <th mat-header-cell id="table-th" *matHeaderCellDef>Carting Date</th>
                                      <td mat-cell id="table-td" *matCellDef="let element">{{ element?.cartingDate ? element?.cartingDate
                                      : '---' }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="readyDate">
                                      <th mat-header-cell id="table-th" *matHeaderCellDef>Ready Date</th>
                                      <td mat-cell id="table-td" *matCellDef="let element">{{ element?.readyDate ? element?.readyDate :
                                      '---' }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="noOfPackages">
                                      <th mat-header-cell id="table-th" *matHeaderCellDef>Packages</th>
                                      <td mat-cell id="table-td" *matCellDef="let element">{{ element?.totalNoOfPkgs ?
                                      element?.totalNoOfPkgs : '---' }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="noOfPallets">
                                      <th mat-header-cell id="table-th" *matHeaderCellDef>Pallets</th>
                                      <td mat-cell id="table-td" *matCellDef="let element;">{{ element?.totalNoOfPallets ?
                                      element?.totalNoOfPallets : 'NA' }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="netWeight">
                                      <th mat-header-cell id="table-th" *matHeaderCellDef>Net Wt</th>
                                      <td mat-cell id="table-td" *matCellDef="let element">{{ element?.netWeight ? element?.netWeight +'
                                      '+ "Kgs" : '---' }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="grossWeight">
                                      <th mat-header-cell id="table-th" *matHeaderCellDef>Gross Wt</th>
                                      <td mat-cell id="table-td" *matCellDef="let element">
                                        {{ element?.grossWeight != null ? formatCBM(element.grossWeight, true) : '---' }}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="cbm">
                                      <th mat-header-cell id="table-th" *matHeaderCellDef>CBM</th>
                                      <td mat-cell id="table-td" *matCellDef="let element;">
                                        {{ element?.cbm ? formatCBM(element?.cbm,false) : '---' }}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="commodityName">
                                      <th mat-header-cell id="table-th" *matHeaderCellDef>Commodity Name</th>
                                      <td mat-cell id="table-td" *matCellDef="let element">
                                        {{ element?.commodityName ? element?.commodityName : '---' }}<br>
                                        <span class="commodity-type-bold" [class.haz-red]="element?.commodityType?.toLowerCase()?.includes('haz')">{{ element?.commodityType ?element?.commodityType : '---' }}</span>
                                      </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="linearOutputColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: linearOutputColumns;"></tr>
                                  </table>
                                </mat-card-content>
                              }
                              <div class="table-wrapper">
                                <table class="detailsTable">
                                  <tr>
                                    <td>POL</td>
                                    <td>{{ data?.polName || '---' }}</td>
                                  </tr>
                                  <tr>
                                    <td>POD</td>
                                    <td>{{ data?.podName || '---' }}</td>
                                  </tr>
                                  <tr>
                                    <td>FDC</td>
                                    <td>{{ data?.destinationName || '---' }}</td>
                                  </tr>
                                  <tr>
                                    <td>Del Type</td>
                                    <td>{{ data?.deliveryType || '---' }}</td>
                                  </tr>
                                  <tr>
                                    <td>Commodity Type</td>
                                    <td>{{ linearOutputDataSource[0]?.commodityType || '---' }}</td>
                                  </tr>
                                  <tr>
                                    <td>HBL Pkgs</td>
                                    <td>{{ packages || 'BL Not Generated' }}</td>
                                  </tr>
                                  <tr>
                                    <td>HBL Pallets</td>
                                    <td>{{ data?.isBlDrafted ? pallets : 'BL Not Generated' }}</td>
                                  </tr>
                                  <tr>
                                    <td>HBL Gross Wt</td>
                                    <td>{{ weight ? weight + ' Kgs' : 'BL Not Generated' }}</td>
                                  </tr>
                                  <tr>
                                    <td>HBL CBM</td>
                                    <td>{{ cbm ? formatCBM(cbm, false) : 'BL Not Generated'}}</td>
                                  </tr>
                                  @if (data && data?.onBoardDate === null && showVessel) {
                                    <tr>
                                      <td>Previous Vessel Voyage</td>
                                      <td>{{ data?.vesselVoyageName ? data?.vesselVoyageName + ' (' + data?.voyageNo + ')' : '---' }}</td>
                                    </tr>
                                    <tr>
                                      <td>ETA ({{data.polName}})</td>
                                      <td>{{ data?.eta || '---'}}</td>
                                    </tr>
                                    <tr>
                                      <td>ETD ({{data.polName}})</td>
                                      <td>{{ data?.etd || '---'}}</td>
                                    </tr>
                                  }
                                  <tr>
                                    <td>{{ data.onBoardDate === null ? 'Planned Vessel Voyage' : 'Vessel Voyage' }}</td>
                                    <td>{{ data?.currentVesselVoyageName ? data?.currentVesselVoyageName + ' (' + data?.currentVoyageNo + ')' : '---' }}</td>
                                  </tr>
                                  <tr>
                                    <td>ETA ({{data.polName}})</td>
                                    <td>{{ data?.currentEta || '---'}}</td>
                                  </tr>
                                  <tr>
                                    <td>ETD ({{data.polName}})</td>
                                    <td>{{ data?.currentEtd || '---'}}</td>
                                  </tr>
                                  <tr>
                                    <td>ETA ({{data?.podName ? data?.podName : '---'}})</td>
                                    <td>{{ data.loadingEtaDate || '---'}}</td>
                                  </tr>
                                  <tr>
                                    <td>Stuffing Cut-Off</td>
                                    <td>{{ data?.stuffingCutOff || '---'}}</td>
                                  </tr>
                                  <tr>
                                    <td>SI Cut-Off</td>
                                    <td>{{ data?.siCutOff || '---'}}</td>
                                  </tr>
                                  <tr>
                                    <td>Port Cut-Off</td>
                                    <td>{{ data?.portCutOff || '---'}}</td>
                                  </tr>
                                  @for (element of linearOutputStuffingDetails; track element) {
                                    <tr>
                                      <td colspan="2" style="font-weight: bold;">Stuffing Details</td>
                                    </tr>
                                    <tr>
                                      <td>Container No</td>
                                      <td>{{ element.containerNo || '---' }} ({{element?.containerName ? element?.containerName : '---'}})</td>
                                    </tr>
                                    <tr>
                                      <td>Line Seal No</td>
                                      <td>{{ element.lineSealNo || '---' }}</td>
                                    </tr>
                                    <tr>
                                      <td>Customs Seal No</td>
                                      <td>{{ element.customSealNo || '---' }}</td>
                                    </tr>
                                    <tr>
                                      <td>Seal Date</td>
                                      <td>{{ element.sealDate || '---' }}</td>
                                    </tr>
                                    <tr>
                                      <td>Gate-In Date</td>
                                      <td>{{ element.portDate || '---' }}</td>
                                    </tr>
                                  }
                                  <tr>
                                    <td>On-Board Date & Time</td>
                                    <td>{{ data?.boardDateTime || '---' }}</td>
                                  </tr>
                                  @for (element of linearOutputRouteDetails; track element) {
                                    <tr>
                                      <td colspan="2" style="font-weight: bold;">Route Info ({{element.polName}} →
                                      {{element.podName}})</td>
                                    </tr>
                                    @if (element.polName === element.podName) {
                                      <tr>
                                        <td>ETA ({{element.podName}})</td>
                                        <td>{{ element.eta || '---' }}</td>
                                      </tr>
                                      <tr>
                                        <td>ATA ({{element.podName}})</td>
                                        <td>{{ element.ata || '---' }}</td>
                                      </tr>
                                    } @else {
                                      <tr>
                                        <td>ETD ({{element.polName}})</td>
                                        <td>{{ element.etd || '---' }}</td>
                                      </tr>
                                      <tr>
                                        <td>ATD ({{element.polName}})</td>
                                        <td>{{ element.atd || '---' }}</td>
                                      </tr>
                                      <tr>
                                        <td>ETA ({{element.podName}})</td>
                                        <td>{{ element.eta || '---' }}</td>
                                      </tr>
                                      <tr>
                                        <td>ATA ({{element.podName}})</td>
                                        <td>{{ element.ata || '---' }}</td>
                                      </tr>
                                    }
                                  }
                                  <tr>
                                    <td>Destuffing Date</td>
                                    <td>{{ data?.trackDestuffingDate || '---' }}</td>
                                  </tr>
                                  @for (element of LinearOutputForwardingDetails; track element) {
                                    <tr>
                                      <td colspan="2" style="font-weight: bold;">Onforwarding Details ({{element.portName}}
                                      →{{element.destinationName}})</td>
                                    </tr>
                                    <tr>
                                      <td>ETD ({{element.portName}})</td>
                                      <td>{{ element.etd || '---' }}</td>
                                    </tr>
                                    <tr>
                                      <td>ATD ({{element.portName}})</td>
                                      <td>{{ element.atd || '---' }}</td>
                                    </tr>
                                    <tr>
                                      <td>ETA ({{element.destinationName}})</td>
                                      <td>{{ element.eta || '---' }}</td>
                                    </tr>
                                    <tr>
                                      <td>ATA ({{element.destinationName}})</td>
                                      <td>{{ element.ata || '---' }}</td>
                                    </tr>
                                    <tr>
                                      <td>Destuffing Date</td>
                                      <td>{{ element?.destuffingDate || '---' }}</td>
                                    </tr>
                                    <tr>
                                      <td>Mode</td>
                                      <td>{{ element?.mode || '---' }}</td>
                                    </tr>
                                  }
                                  <tr>
                                    <td>DO Release Date</td>
                                    <td>{{ data?.doReleaseDate || '---'}}</td>
                                  </tr>
                                  @if (data.deliveryType == 'CFS') {
                                    <tr>
                                      <td>Phy Pick-Up Date</td>
                                      <td>{{ data?.physicalReleaseDate || '---' }}</td>
                                    </tr>
                                  }
                                  @if (data?.deliveryType !== 'CFS') {
                                    <tr>
                                      <td>Tentative Delivery Date</td>
                                      <td>{{ data?.tentativeClearanceDate || '---' }}</td>
                                    </tr>
                                  }
                                  @if (data?.deliveryType !== 'CFS') {
                                    <tr>
                                      <td>Actual Delivery Date</td>
                                      <td>{{ data?.actualDeliveryDate || '---' }}</td>
                                    </tr>
                                  }
                                  <tr>
                                    <td>{{ data?.deliveryType === 'CFS' ? 'Delivery Agent' : 'Door Delivery Agent' }}</td>
                                    <td style="white-space: pre-line;">
                                      @if (data?.deliveryType === 'CFS') {
                                        {{ openTrackingForm.get('deliveryAgent')?.value || '---' }}
                                      } @else {
                                        {{ data?.isPlanConsol
                                        ? (openTrackingForm.get('doorDeliveryAgent')?.value?.trim() || data?.doorDeliveryAgent || '---')
                                        : (data?.doorDeliveryAgent?.trim() || data?.doorDeliveryAgent || '') }}
                                      }
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Remarks</td>
                                    <td>{{ data?.remarkDate && data?.remarkText ? data.remarkDate + ': ' + data.remarkText : '' }} </td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </div>
                        }
                        @if (data && showTable) {
                          <mat-card-content class="odd-bold" id="booking">
                            <div class="flex-container">
                              <h3 class="block-heading section-heading-booking">Booking Details</h3>
                              <h3 class="joint"></h3>
                            </div>
                            <div class="mat-chip-list-wrapper">
                              <div class="label-value-row">
                                <div class="label-value">
                                  <span id="label">HBL No</span>
                                  <span id="value">{{ this.data?.blNo ? this.data?.blNo : '---'}}</span>
                                </div>
                              </div>
                              <div class="label-value-row">
                                <div class="label-value">
                                  <span id="label">POL</span>
                                  <span id="value">{{ this.data?.polName ? this.data?.polName : '---'}}</span>
                                </div>
                                <div class="label-value">
                                  <span id="label">POD</span>
                                  <span id="value">{{ this.data?.podName ? this.data?.podName : '---'}}</span>
                                </div>
                                <div class="label-value">
                                  <span id="label">FDC</span>
                                  <span id="value"> {{ this.data?.destinationName ? this.data?.destinationName : '---'}}</span>
                                </div>
                                <div class="label-value">
                                  <span id="label">Delivery Type</span>
                                  <span id="value">{{ this.data?.deliveryType ? this.data?.deliveryType : '---'}}</span>
                                </div>
                              </div>
                              <div class="label-value-row">
                                <div class="label-value">
                                  <span id="label">HBL Packages</span>
                                  <span id="value">{{ packages ? packages : 'BL Not Generated' }}</span>
                                </div>
                                <div class="label-value">
                                  <span id="label">HBL Pallets</span>
                                  <span id="value">{{ data?.isBlDrafted ? pallets : 'BL Not Generated' }}</span>
                                </div>
                                <div class="label-value">
                                  <span id="label">HBL CBM</span>
                                  <span id="value">{{ cbm ? formatCBM(cbm, false) : 'BL Not Generated'}}</span>
                                </div>
                                <div class="label-value">
                                  <span id="label">HBL Gross Weight</span>
                                  <span id="value">{{weight ? formatCBM(weight, true) : 'BL Not Generated'}}</span>
                                </div>
                              </div>
                              <div>
                                @if (data) {
                                  <mat-card-content class="background-theme">
                                    <h3 class="shipping-title">Shipping Bill Details</h3>
                                    <table mat-table [dataSource]="billDetailsDataSource">
                                      <ng-container matColumnDef="billNo">
                                        <th mat-header-cell id="table-th" *matHeaderCellDef>
                                          SBill No.<br>
                                        </th>
                                        <td mat-cell id="table-td" *matCellDef="let element;">
                                          {{ element?.billNo ? element?.billNo : '---' }}<br>
                                          ({{ element?.originName ? element?.originName : '---' }})
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="cartingDate">
                                        <th mat-header-cell id="table-th" *matHeaderCellDef>Carting / Cargo Recd Date</th>
                                        <td mat-cell id="table-td" *matCellDef="let element">
                                          {{ (element?.cartingDate ? element?.cartingDate : '---') }}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="cargo">
                                        <th mat-header-cell id="table-th" *matHeaderCellDef> Cargo Status</th>
                                        <td mat-cell id="table-td" *matCellDef="let element">
                                          {{ element?.readyDate ? 'Ready' : 'Carted' }}<br>
                                          {{ element?.readyDate ? element?.readyDate : '---' }}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="commodityType">
                                        <th mat-header-cell id="table-th" *matHeaderCellDef> Commodity Name </th>
                                        <td mat-cell id="table-td" *matCellDef="let element">
                                          {{ element?.commodityName ? element?.commodityName : '---' }}<br>
                                          {{ element?.commodityType ? element?.commodityType : '---' }}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="readyDate">
                                        <th mat-header-cell id="table-th" *matHeaderCellDef> Clearance Date</th>
                                        <td mat-cell id="table-td" *matCellDef="let element">
                                          {{ element?.readyDate ? element?.readyDate : '---' }}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="invoiceNo">
                                        <th mat-header-cell id="table-th" *matHeaderCellDef> Cust Tax Inv</th>
                                        <td mat-cell id="table-td" *matCellDef="let element">
                                          {{ element?.invoiceNo ? element?.invoiceNo : '---' }}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="noOfPackages">
                                        <th mat-header-cell id="table-th" *matHeaderCellDef> Packages </th>
                                        <td mat-cell id="table-td" *matCellDef="let element">
                                          {{ element?.totalNoOfPkgs ? element?.totalNoOfPkgs : '---' }}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="noOfPallets">
                                        <th mat-header-cell id="table-th" *matHeaderCellDef> Pallets </th>
                                        <td mat-cell id="table-td" *matCellDef="let element;">
                                          {{ element?.totalNoOfPallets ? element?.totalNoOfPallets : 'NA' }}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="netWeight">
                                        <th mat-header-cell id="table-th" *matHeaderCellDef>Net Wt</th>
                                        <td mat-cell id="table-td" *matCellDef="let element">
                                          {{element?.netWeight ? formatWeight(element?.netWeight) : '---'}}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="grossWeight">
                                        <th mat-header-cell id="table-th" *matHeaderCellDef>Gross Wt</th>
                                        <td mat-cell id="table-td" *matCellDef="let element">
                                          {{element?.grossWeight ? formatWeight(element?.grossWeight) : '---'}}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="cbm">
                                        <th mat-header-cell id="table-th" *matHeaderCellDef> CBM </th>
                                        <td mat-cell id="table-td" *matCellDef="let element;">
                                          {{ element?.cbm != null ? formatCBM(element.cbm, false) : '---' }}
                                        </td>
                                      </ng-container>
                                      <tr mat-header-row *matHeaderRowDef="billColumns"></tr>
                                      <tr mat-row *matRowDef="let row; columns: billColumns;"></tr>
                                    </table>
                                  </mat-card-content>
                                }
                              </div>
                            </div>
                          </mat-card-content>
                        }
                        <br>
                          @if (data && data?.onBoardDate === null && showTable) {
                            <mat-card-content class="cargo-odd-bold vessel-details" id="planning">
                              <div class="flex-container">
                                <h3 class="block-heading section-heading-vessel">Vessel Planning Details</h3>
                                <h3 class="joint joint-top"></h3>
                              </div>
                              <div class="mat-chip-list-wrapper">
                                @if (showVessel) {
                                  <div class="label-value-row">
                                    <div class="label-value-bookingDetail">
                                      <span id="label">Previous Vessel</span>
                                      @if (data?.vesselVoyageName !== 'null') {
                                        <span id="value">{{ data?.vesselVoyageName + ' (' + data?.voyageNo + ')' }}</span>
                                      }
                                    </div>
                                    <div class="label-value-bookingDetail">
                                      <span id="label">ETA (POL)</span>
                                      <span id="value">{{ data?.eta}}</span>
                                    </div>
                                    <div class="label-value-bookingDetail">
                                      <span id="label">ETD (POL)</span>
                                      <span id="value">{{ data?.etd}}</span>
                                    </div>
                                  </div>
                                }
                                <div class="label-value-row">
                                  <div class="label-value-bookingDetail">
                                    <span id="label">Planned Vessel Voyage</span>
                                    <span id="value">{{ data?.currentVesselVoyageName ? data?.currentVesselVoyageName + ' (' + data?.currentVoyageNo + ')' : '---' }}</span>
                                  </div>
                                  <div class="label-value-bookingDetail">
                                    <span id="label">ETA (POL)</span>
                                    <span id="value">{{ data?.currentEta}}</span>
                                  </div>
                                  <div class="label-value-bookingDetail">
                                    <span id="label">ETD (POL)</span>
                                    <span id="value">{{ data?.currentEtd}}</span>
                                  </div>
                                </div>
                                <div class="label-value-row">
                                  <div class="label-value-bookingDetail">
                                    <span id="label">Stuffing Cut-Off</span>
                                    <span id="value">{{ data?.stuffingCutOff}}</span>
                                  </div>
                                  <div class="label-value-bookingDetail">
                                    <span id="label">SI Cut-Off</span>
                                    <span id="value">{{ data?.siCutOff}}</span>
                                  </div>
                                  <div class="label-value-bookingDetail">
                                    <span id="label">Port Cut-Off</span>
                                    <span id="value">{{ data?.portCutOff}}</span>
                                  </div>
                                </div>
                              </div>
                            </mat-card-content>
                            }<br>
                            @if (data && showTable) {
                              <mat-card-content id="stuffing">
                                <div class="flex-container">
                                  <h3 class="block-heading section-heading-stuffing"> Stuffing & Port-In Details </h3>
                                  <h3 class="joint joint-top"></h3>
                                </div>
                                <div class="mat-chip-list-wrapper">
                                  <table mat-table [dataSource]="stuffingDetailsDataSource">
                                    <ng-container matColumnDef="containerNo">
                                      <th mat-header-cell id="table-th" *matHeaderCellDef>Container No</th>
                                      <td mat-cell id="table-td" *matCellDef="let element;">
                                        {{ element?.containerNo ? element?.containerNo : '---' }} ({{element?.containerName ? element?.containerName : '---'}})
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="lineSealNo">
                                      <th mat-header-cell id="table-th" *matHeaderCellDef> Line Seal No </th>
                                      <td mat-cell id="table-td" *matCellDef="let element">
                                        {{ element?.lineSealNo ? element?.lineSealNo : '---' }}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="customSealNo">
                                      <th mat-header-cell id="table-th" *matHeaderCellDef> Customs Seal No </th>
                                      <td mat-cell id="table-td" *matCellDef="let element;">
                                        {{ element?.customSealNo ? element?.customSealNo : '---' }}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="sealDate">
                                      <th mat-header-cell id="table-th" *matHeaderCellDef> Seal Date </th>
                                      <td mat-cell id="table-td" *matCellDef="let element;">
                                        {{ element?.sealDate ? element?.sealDate: '---' }}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="portDate">
                                      <th mat-header-cell id="table-th" *matHeaderCellDef> Port-In Date </th>
                                      <td mat-cell id="table-td" *matCellDef="let element;">
                                        {{ element?.portDate ? element?.portDate: '---' }}
                                      </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="stuffingColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: stuffingColumns;"></tr>
                                  </table>
                                </div>
                              </mat-card-content>
                              }<br>
                              @if (data && showTable) {
                                <mat-card-content class="even-gap load-details" id="loading">
                                  <div class="flex-container">
                                    <h3 class="block-heading section-heading-loading">Loading Vessel Details</h3>
                                    <h3 class="joint joint-top"></h3>
                                  </div>
                                  <div class="mat-chip-list-wrapper">
                                    <div class="label-value-row">
                                      <div class="label-value">
                                        <span id="label">Loading Vessel Voyage</span>
                                        <span id="value">{{ data?.loadingVesselName ? data?.loadingVesselName + ' (' + data?.currentVoyageNo + ')' : '---' }}</span>
                                      </div>
                                      <div class="label-value">
                                        <span id="label">On-Board Date & Time</span>
                                        <span id="value">
                                          @if (data?.onBoardDate) {
                                            <span>{{ data?.boardDateTime ? data?.boardDateTime : '---'}}</span>
                                          }
                                        </span>
                                      </div>
                                      <div class="label-value">
                                        <span id="label">ETD ({{data?.polName ? data?.polName : '---'}})</span>
                                        <span id="value">{{ data?.loadingEtdDate ? data?.loadingEtdDate : '---'}}</span>
                                      </div>
                                      <div class="label-value">
                                        <span id="label">ATD ({{data?.polName ? data?.polName : '---'}})</span>
                                        <span id="value">{{ data?.loadingSailDate ? data?.loadingSailDate : '---'}}</span>
                                      </div>
                                      <div class="label-value">
                                        <span id="label">ETA ({{data?.podName ? data?.podName : '---'}})</span>
                                        <span id="value">{{ data?.loadingEtaDate ? data?.loadingEtaDate : '---'}}</span>
                                      </div>
                                      <div class="label-value">
                                        <span id="label">ATA ({{data?.podName ? data?.podName : '---'}})</span>
                                        <span id="value">{{ data?.loadingAtaDate ? data?.loadingAtaDate : '---'}}</span>
                                      </div>
                                    </div>
                                  </div>
                                </mat-card-content>
                              }
                              @if (data.routeDetails[0]?.planConsolId && showTable) {
                                <mat-card-content class="cargo-odd-bold" id="lineRoute">
                                  <div class="flex-container">
                                    <h3 class="block-heading section-heading-liner"> Liner Route & Arrival Details </h3>
                                    <h3 class="joint joint-top"></h3>
                                  </div>
                                  <div class="mat-chip-list-wrapper">
                                    <div class="label-value-row">
                                      <div class="label-value">
                                        <span id="label">Consortium Service</span>
                                        <span id="value">{{ data?.consortiumName ? data?.consortiumName : '---' }}</span>
                                      </div>
                                      <div class="label-value">
                                        <span id="label">Shipping Line</span>
                                        <span id="value">{{ data?.lineName ? data?.lineName : '---' }}</span>
                                      </div>
                                    </div>
                                    <mat-card-content>
                                      <div class="fw-semibold text-center large-heading">Shipping Line Route</div><br />
                                      <div class="d-flex justify-content-center">
                                        <mat-chip-grid>
                                          @for (route of routes; track route; let last = $last) {
                                            <div class="node">
                                              <mat-chip-row>{{ route.name }}</mat-chip-row>
                                              @if (!last) {
                                                <mat-icon>arrow_right_alt</mat-icon>
                                              }
                                            </div>
                                          }
                                        </mat-chip-grid>
                                      </div>
                                    </mat-card-content>
                                    <div>
                                      <table mat-table [dataSource]="lineRouteDataSource">
                                        <ng-container matColumnDef="polName">
                                          <th mat-header-cell id="table-th" *matHeaderCellDef> POL / POD </th>
                                          <td mat-cell *matCellDef="let element;">
                                            {{ element?.polName ? element?.polName : '---' }}
                                          </td>
                                        </ng-container>
                                        <ng-container matColumnDef="mode">
                                          <th mat-header-cell id="table-th" *matHeaderCellDef> Mode </th>
                                          <td mat-cell *matCellDef="let element">
                                            {{ element?.mode ? element?.mode : '---' }}
                                          </td>
                                        </ng-container>
                                        <ng-container matColumnDef="vesselVoyage">
                                          <th mat-header-cell id="table-th" *matHeaderCellDef> Vessel Voy / Truck / Others </th>
                                          <td mat-cell id="table-td" *matCellDef="let element;">
                                            {{ element?.vesselVoyageName ? element?.vesselVoyageName : '---' }}
                                          </td>
                                        </ng-container>
                                        <ng-container matColumnDef="etd">
                                          <th mat-header-cell id="table-th" *matHeaderCellDef> ETD </th>
                                          <td mat-cell id="table-td" *matCellDef="let element;">
                                            {{ element?.etd ? element?.etd : '---' }}
                                          </td>
                                        </ng-container>
                                        <ng-container matColumnDef="atd">
                                          <th mat-header-cell id="table-th" *matHeaderCellDef> ATD </th>
                                          <td mat-cell id="table-td" *matCellDef="let element;">
                                            {{ element?.atd ? element?.atd : '---' }}
                                          </td>
                                        </ng-container>
                                        <ng-container matColumnDef="podName">
                                          <th mat-header-cell id="table-th" *matHeaderCellDef> POD/FDC </th>
                                          <td mat-cell id="table-td" *matCellDef="let element;">
                                            {{ element?.podName ? element?.podName : '---' }}
                                          </td>
                                        </ng-container>
                                        <ng-container matColumnDef="eta">
                                          <th mat-header-cell id="table-th" *matHeaderCellDef> ETA </th>
                                          <td mat-cell id="table-td" *matCellDef="let element;">
                                            {{ element?.eta ? element?.eta : '---' }}
                                          </td>
                                        </ng-container>
                                        <ng-container matColumnDef="ata">
                                          <th mat-header-cell id="table-th" *matHeaderCellDef> ATA </th>
                                          <td mat-cell id="table-td" *matCellDef="let element;">
                                            {{ element?.ata ? element?.ata : '---' }}
                                          </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="lineRouteColumn"></tr>
                                        <tr mat-row *matRowDef="let row; columns: lineRouteColumn;"></tr>
                                      </table>
                                    </div>
                                  </div>
                                </mat-card-content>
                              }
                              @if (data && showTable) {
                                <mat-card-content class="cargo-odd-bold" id="forwarding">
                                  <div class="flex-container">
                                    <h3 class="block-heading section-heading-forwarding"> Container Destuffing & Cargo Onforwarding Details </h3>
                                    <h3 class="joint joint-top"></h3>
                                  </div>
                                  <div class="mat-chip-list-wrapper">
                                    <div class="label-value-row">
                                      <div class="label-value">
                                        <span id="label">Destuffing Date</span>
                                        <span id="value">{{ data?.trackDestuffingDate ? data?.trackDestuffingDate : '---' }}</span>
                                      </div>
                                      @if (forwardSize == 0) {
                                        <div class="label-value">
                                          <span id="label">DO Release Date</span>
                                          <span id="value">{{ data?.doReleaseDate ? data?.doReleaseDate : '---'}}</span>
                                        </div>
                                      }
                                      @if (forwardSize == 0 && data?.deliveryType == 'CFS') {
                                        <div class="label-value">
                                          <span id="label">Phy Pick-Up Date</span>
                                          <span id="value">{{ data?.physicalReleaseDate ? data?.physicalReleaseDate : '---'}}</span>
                                        </div>
                                      }
                                      @if (forwardSize == 0 && data?.deliveryType !== 'CFS') {
                                        <div class="label-value">
                                          <span id="label">Tentative Delivery Date</span>
                                          <span id="value">{{ data?.tentativeClearanceDate ? data?.tentativeClearanceDate : '---'}}</span>
                                        </div>
                                      }
                                      @if (forwardSize == 0 && data?.deliveryType !== 'CFS') {
                                        <div class="label-value">
                                          <span id="label">Actual Delivery Date</span>
                                          <span id="value">{{ data?.actualDeliveryDate ? data?.actualDeliveryDate : '---'}}</span>
                                        </div>
                                      }
                                    </div>
                                    @if (forwardSize > 0) {
                                      <mat-card-content>
                                        @if (!showForwarding) {
                                          <div>
                                            <h3 class="route-title">Route / Onforwarding Details </h3>
                                            <div>
                                              <table mat-table [dataSource]="forwardDetailsDataSource">
                                                <ng-container matColumnDef="port">
                                                  <th mat-header-cell id="table-th" *matHeaderCellDef> POD / FDC </th>
                                                  <td mat-cell *matCellDef="let element;">
                                                    {{ element?.portName ? element?.portName : '---' }}
                                                  </td>
                                                </ng-container>
                                                <ng-container matColumnDef="mode">
                                                  <th mat-header-cell id="table-th" *matHeaderCellDef> Mode </th>
                                                  <td mat-cell *matCellDef="let element">
                                                    {{ element?.mode ? element?.mode : '---' }}
                                                  </td>
                                                </ng-container>
                                                <ng-container matColumnDef="vesselVoyage">
                                                  <th mat-header-cell id="table-th" *matHeaderCellDef> Vessel Voyage </th>
                                                  <td mat-cell id="table-td" *matCellDef="let element;">
                                                    {{ element?.vesselVoyage ? element?.vesselVoyage : '---' }}
                                                  </td>
                                                </ng-container>
                                                <ng-container matColumnDef="containerNo">
                                                  <th mat-header-cell id="table-th" *matHeaderCellDef> Container No </th>
                                                  <td mat-cell id="table-td" *matCellDef="let element;">
                                                    {{ element?.containerNo ? element?.containerNo : '---' }}
                                                  </td>
                                                </ng-container>
                                                <ng-container matColumnDef="etd">
                                                  <th mat-header-cell id="table-th" *matHeaderCellDef> ETD </th>
                                                  <td mat-cell id="table-td" *matCellDef="let element;">
                                                    {{ element?.etd ? element?.etd : '---' }}
                                                  </td>
                                                </ng-container>
                                                <ng-container matColumnDef="atd">
                                                  <th mat-header-cell id="table-th" *matHeaderCellDef> ATD </th>
                                                  <td mat-cell id="table-td" *matCellDef="let element;">
                                                    {{ element?.atd ? element?.atd : '---' }}
                                                  </td>
                                                </ng-container>
                                                <ng-container matColumnDef="fdc">
                                                  <th mat-header-cell id="table-th" *matHeaderCellDef> Destination </th>
                                                  <td mat-cell id="table-td" *matCellDef="let element;">
                                                    {{ element?.destinationName ? element?.destinationName : '---' }}
                                                  </td>
                                                </ng-container>
                                                <ng-container matColumnDef="eta">
                                                  <th mat-header-cell id="table-th" *matHeaderCellDef> ETA </th>
                                                  <td mat-cell id="table-td" *matCellDef="let element;">
                                                    {{ element?.eta ? element?.eta : '---' }}
                                                  </td>
                                                </ng-container>
                                                <ng-container matColumnDef="ata">
                                                  <th mat-header-cell id="table-th" *matHeaderCellDef> ATA </th>
                                                  <td mat-cell id="table-td" *matCellDef="let element;">
                                                    {{ element?.ata ? element?.ata : '---' }}
                                                  </td>
                                                </ng-container>
                                                <ng-container matColumnDef="destuffing">
                                                  <th mat-header-cell id="table-th" *matHeaderCellDef> Destuffing Date </th>
                                                  <td mat-cell id="table-td" *matCellDef="let element;">
                                                    {{ element?.destuffingDate ? element?.destuffingDate : '---' }}
                                                  </td>
                                                </ng-container>
                                                <tr mat-header-row *matHeaderRowDef="forwardColumns"></tr>
                                                <tr mat-row *matRowDef="let row; columns: forwardColumns;"></tr>
                                              </table>
                                            </div>
                                          </div>
                                        }
                                      </mat-card-content>
                                    }
                                    @if (forwardSize > 0) {
                                      <div class="label-value-row">
                                        <div class="label-value">
                                          <span id="label">DO Release Date</span>
                                          <span id="value">{{ data?.doReleaseDate}}</span>
                                        </div>
                                        @if (data?.deliveryType == 'CFS') {
                                          <div class="label-value">
                                            <span id="label">Phy Pick-Up Date</span>
                                            <span id="value">{{ data?.physicalReleaseDate}}</span>
                                          </div>
                                        }
                                        @if (data?.deliveryType !== 'CFS') {
                                          <div class="label-value">
                                            <span id="label">Tentative Delivery Date</span>
                                            <span id="value">{{ data?.tentativeClearanceDate || '---'}}</span>
                                          </div>
                                          <div class="label-value">
                                            <span id="label">Actual Delivery Date</span>
                                            <span id="value">{{ data?.actualDeliveryDate || data?.physicalReleaseDate || '---'}}</span>
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                </mat-card-content>
                              }
                              <br>
                                @if (data && showTable) {
                                  <mat-card-content class="textAreaSize">
                                    @if (!isDeliveryType) {
                                      <div class="flex-container" id="DeliveryDet">
                                        <h3 class="block-heading section-heading-delivery">Delivery Agent Details</h3>
                                        <h3 class="joint joint-top"></h3>
                                      </div>
                                      <div class="mat-chip-list-wrapper">
                                        <span id="value-field">{{ data?.deliveryAgent }}</span>
                                      </div>
                                    }
                                    @if (isDeliveryType) {
                                      <div class="flex-container" id="DoorDeliveryDet">
                                        <h3 class="block-heading section-heading-delivery">Door Delivery Agent</h3>
                                        <h3 class="joint joint-top"></h3>
                                      </div>
                                      <div class="mat-chip-list-wrapper">
                                        <span id="value-field">
                                          {{ data?.isPlanConsol
                                          ? (data?.doorDeliveryAgent?.trim() || data?.draftDoorDeliveryAgent || '')
                                          : (data?.doorDeliveryAgent?.trim() || data?.draftDoorDeliveryAgent || '') }}
                                        </span>
                                      </div>
                                    }
                                  </mat-card-content>
                                }
                                @if (data && showTable) {
                                  <mat-card-content class="textAreaSize">
                                    <div class="flex-container">
                                      <h3 class="block-heading section-heading-remark">Agent Remark</h3>
                                      <h3 class="joint joint-top"></h3>
                                    </div>
                                    <div class="mat-chip-list-wrapper">
                                      <span id="value-field">{{ data?.remarkDate && data?.remarkText ? data.remarkDate + ': ' + data.remarkText : '' }}</span>
                                    </div>
                                  </mat-card-content>
                                }
                                <button (click)="handleScroll()" id="scrollBtn" [attr.title]="isAtBottom ? 'Scroll Up' : 'Scroll Down'">
                                  <mat-icon>{{ isAtBottom ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                                </button>
                                <div class="disclaimer-text"><span class="DiscInfo">**Disclaimer**</span><br>The tracking information provided above is for reference purposes only, the Company does not claim that the information is 100% accurate.<br>
                              The data is collected from different sources in India and overseas, using manual or automated processes. Please reach out to GRT for specific queries or information.</div>
                            </div>
                          }
                        </mat-card>
                      </form>
                    </div>
